import type { FaireProductEntity } from "../../entity_types/product";

export const p_jqz8jybkae: FaireProductEntity = {
  token: "p_jqz8jybkae",
  type: "product",
  name: "MN Abbey Road Socks",
  brandName: "Adam Turman Artwork Co",
  imageUrl:
    "https://cdn.faire.com/fastly/f6b4e8f408a97b342a94dc07cdfa5f70fad35987fa90d7e09b5f0157f631bec6.jpeg",
  priceDollars: 5.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/43459383460ca2fb5f3fc971215f1e2635d29a4ec30d6f8a89b5c1eb21508054.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
